module.exports = __webpack_public_path__ + "img/bingo_ball-26.4aca17c2.png";